import React from 'react';

export default class Slider extends React.Component{
	constructor(props){
		super(props);
		this.state={
			slideCount:0,
			isDragStarted:false
		};
		this.toRotateSlider=this.toRotateSlider.bind(this);
		this.toDrag=this.toDrag.bind(this);
		this.dragStart=this.dragStart.bind(this);
		this.dragEnd=this.dragEnd.bind(this);
		this.cube=React.createRef();
	}
	toRotateSlider(n){
		const a = this.cube.current;
		if(a.style.transform==''){
			a.style.transform=`rotateY(${n*90}deg)`;
			this.setState({slideCount:this.state.slideCount+n});
		}else{
			a.style.transform=`rotateY(${(this.state.slideCount+n)*90}deg)`;
			this.setState({slideCount:this.state.slideCount+n});
		};
	}
	dragStart(e){
		const img = document.createElement('img');
		img.src=require('../../img/arrow.png');
		img.style.opacity='0';
		if(e.clientX) e.dataTransfer.setDragImage(img,10000,0);
		this.dragStarted=[e.clientX||e.touches[0].clientX,e.clientY||e.touches[0].clientY];
		this.setState({isDragStarted:!this.state.isDragStarted});
	}
	toDrag(e){
		if(e.type=='touchmove')document.getElementById('root').style.overflow='hidden';
		const xy = [e.clientX||e.touches[0].clientX,e.clientY||e.touches[0].clientY];
		this.cube.current.style.transform=`rotateY(${xy[0]-this.dragStarted[0]}deg) rotateX(${this.props.product?(this.dragStarted[1]-xy[1]):0}deg)`;
	}
	dragEnd(e){
		document.getElementById('root').style.overflow='';
		this.setState({isDragStarted:!this.state.isDragStarted});
		this.cube.current.style.transform='';
	}
	render(){
		return(
			<div className={`slider anime ${this.props.showAnime?'show':null}`}>
				{
					this.props.arrow&&(<div className='arrow left'>
						<img onClick={() =>this.toRotateSlider(1)}
							src={require('../../img/arrow.png')}
						/>
					</div>)
				}
				<div onDragOver={this.toDrag}
					onTouchMove={this.toDrag}
					onDragStart={this.dragStart}
					onTouchStart={this.dragStart}
					onDragEnd={this.dragEnd}
					onTouchEnd={this.dragEnd}
					ref={this.cube} className='cube'
					style={this.state.isDragStarted?{transitionDuration:'0s'}:null}
					>
					{
						this.props.img.map((i,n) =>{
							if(n>3)return false;
							return (<div key={n} className={`img img-${n}`}>
								<img src={require('../../img/'+i)} alt='гроубокс'/>
							</div>)
						})
					}
					{
						this.props.product&&<div className='img img-4'>HOUSING</div>
					}
					{
						this.props.product&&(<ul className='img img-5 des'>
								<li><span>назва : </span>{this.props.product.name}</li>
								<li><span>об'эм : </span>{this.props.product.amount} m2</li>
								<li><span>дiаметр : </span>{this.props.product.diametr} см</li>
								<li><span>висота : </span>{this.props.product.height} см</li>
								<li><span>матерiал : </span>{this.props.product.material}</li>
								<li><span>цiна : </span>{this.props.product.price} ₴</li>
							</ul>)
					}
				</div>
				{
					this.props.arrow&&(<div className='arrow right'>
						<img onClick={() =>this.toRotateSlider(-1)}
							src={require('../../img/arrow.png')}
						/>
					</div>)
				}
			</div>
		)
	}
}